import React, { FC } from 'react'

import styles from './BannerSectionPreloader.module.scss'

export const BannerSectionPreloader: FC = () => (
  <div className={styles.BannerSectionPreloader}>
    <div className={styles.LoaderImage} />
  </div>
)
